module.exports = __webpack_public_path__ + "static/media/astro_bush.d4c4a957.png";